<template>
  <Loader v-if="loading"></Loader>
  <div v-else class="xs-12 m-8 l-9 myhome-profile-orders">
    <h2 class="dea-heading--medium-xxl myhome-profile-orders__title" tabindex="0">
      <template v-if="user.parent || user.student">
        I miei ordini ebook
      </template>
      <template v-else>
        I miei ordini
      </template>
    </h2>
    <div v-if="ordersList.length" class="my-profile-orders__list">
      <CardOrderEbook v-for="(order, index) in ordersList" :key="index" :order="order" />
    </div>
    <template v-else>
      <NoResults>
        <template #title>
          Non hai effettuato ordini su Deascuola
        </template>
        <template #default>
          {{
            user.parent
              ? "Qui troverai le ricevute degli ebook che hai acquistato direttamente su deascuola.it"
              : "Siamo spiacenti ma non sono stati trovati ordini."
          }}
        </template>
      </NoResults>
    </template>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import CardOrderEbook from "@/components/patterns/CardOrderEbook";
import Loader from "@/components/elements/Loader";
import NoResults from "@/components/elements/NoResults";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfileOrdersList",
  components: { CardOrderEbook, Loader, NoResults },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      ordersList: [],
    };
  },
  mounted() {
    setFocus("myhome-profile-orders__title");

    const headers = {};
    headers.Authorization = `Bearer ${this.$cookies.get("deatoken")}`;
    fetch(this.$root.config.ordersListURL, { headers })
      .then(response => {
        this.loading = false;
        if (!response.ok) {
          throw new Error("Error");
        }
        return response.json();
      })
      .then(data => {
        this.ordersList = data;
      })
      .catch(error => {
        Sentry.captureException(error);
      });
  },
  activated() {
    setFocus("myhome-profile-orders__title");
  },
};
</script>

<style lang="scss">
.myhome-profile-orders {
  &__title {
    margin-top: 0;
  }

  .dea-ico-no-result {
    display: none;
  }
}
</style>
